import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { zIndices } from './constants';
import ButtonLink from './ButtonLink';
import type { Props as PropsSchema } from './props-schema';
import withSafeAreaInsetBottom from 'shared/lib/withSafeAreaInsetBottom';

export default function FloatingCTA(props: PropsSchema['floatingCta']) {
  const { label, url, appHandlerKey } = props;

  return (
    <Container zIndex={zIndices.floatingCta}>
      <ButtonLink
        minWidth='264px'
        my='12px'
        href={url}
        appHandlerKey={appHandlerKey}
      >
        {label}
      </ButtonLink>
    </Container>
  );
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  position: 'fixed',
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  backdropFilter: 'blur(10px)',
  paddingBottom: withSafeAreaInsetBottom(),

  [theme.mediaQueries.md]: {
    display: 'none',
  }
}));
